import React from 'react'

import { formField } from 'decorators'

import Select from './Select'

export default formField(props => <Select {...props} />)
